const error404PageStyle = {
  grey: {
    backgroundColor: "#f4f4f4",
  },
  noAccessBox: {
    maxWidth: "550px",
    margin: "0 auto",
    textAlign: "center",
    padding: "2rem",
  },
};
export default error404PageStyle;
